/**
 * Converts a standard JavaScript Date day (0-6, where 0 is Sunday)
 * to our application's standard (0-6, where 0 is Monday).
 * @param jsDay The day index from Date.getDay()
 * @returns The day index where 0=Monday, 6=Sunday
 */
export function convertJsDayToMondayZero(jsDay: number): number {
  return (jsDay + 6) % 7;
}

/**
 * Returns the full name of the day for a given Monday-zero index.
 * @param day The day index (0=Monday, 6=Sunday)
 * @returns The name of the day in Spanish
 */
export function getDayNameMondayZero(day: number): string {
  const days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  return days[day];
}

/**
 * Returns the short name of the day for a given Monday-zero index.
 * @param day The day index (0=Monday, 6=Sunday)
 * @returns The short name of the day (e.g. 'Lun')
 */
export function getDayShortNameMondayZero(day: number): string {
  const days = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
  return days[day];
}
